import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '../contexts/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown } = FiIcons;

const Header = () => {
  const { t, currentLanguage, changeLanguage } = useLanguage();
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg border-b border-gray-200/20 dark:border-gray-700/20 sticky top-0 z-40"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* NUEVO: Logo y título como enlace para reiniciar */}
          <Link to="/" className="no-underline">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3 cursor-pointer"
            >
              <Logo size="sm" />
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  {t('appName')}
                </h1>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  {t('subtitle')}
                </p>
              </div>
            </motion.div>
          </Link>

          <div className="flex items-center space-x-4">
            <div className="relative">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowLanguageMenu(!showLanguageMenu)}
                className="flex items-center space-x-2 px-3 py-2 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {currentLanguage.toUpperCase()}
                </span>
                <motion.div
                  animate={{ rotate: showLanguageMenu ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <SafeIcon icon={FiChevronDown} className="w-4 h-4 text-gray-500" />
                </motion.div>
              </motion.button>

              <AnimatePresence>
                {showLanguageMenu && (
                  <LanguageSelector
                    currentLanguage={currentLanguage}
                    onLanguageChange={changeLanguage}
                    onClose={() => setShowLanguageMenu(false)}
                  />
                )}
              </AnimatePresence>
            </div>

            <ThemeToggle />
          </div>
        </div>
      </div>

      {showLanguageMenu && (
        <div 
          className="fixed inset-0 z-30" 
          onClick={() => setShowLanguageMenu(false)} 
        />
      )}
    </motion.header>
  );
};

export default Header;